import { useQuery } from '@tanstack/react-query';
import { keys } from '@/lib/queryKeys';
import { fetchInventoryHistory } from './api';

/** Only fetched once the row's "History" toggle is opened — see InventoryTab.tsx. */
export function useInventoryHistory(inventoryId: number | null) {
  return useQuery({
    queryKey: keys.pharmacy.inventoryHistory(inventoryId ?? -1),
    queryFn: () => fetchInventoryHistory(inventoryId as number),
    enabled: inventoryId != null,
  });
}
